import CertificateModel from '../models/CertificateModel';
import toast from 'react-hot-toast';

class CertificateController {
  constructor() {
    this.model = CertificateModel;
  }

  async issueCertificate(certificateData, navigate) {
    const result = await this.model.issueCertificate(certificateData);
    
    if (result.success) {
      toast.success('Certificate issued successfully!');
      navigate('/my-certificates');
    } else {
      toast.error(result.message);
    }
    
    return result;
  }

  async loadMyCertificates() {
    try {
      const certificates = await this.model.getMyCertificates();
      return certificates;
    } catch (error) {
      toast.error(error.message);
      return [];
    }
  }

  async loadCertificateDetails(id) {
    try {
      const certificate = await this.model.getCertificateById(id);
      return certificate;
    } catch (error) {
      toast.error(error.message);
      return null;
    }
  }

  async verifyCertificate(id, method = 'id') {
    try {
      let result;
      
      switch (method) {
        case 'id':
          result = await this.model.verifyCertificate(id);
          break;
        case 'hash':
          result = await this.model.verifyByHash(id);
          break;
        case 'qr':
          result = await this.model.verifyByQR(id);
          break;
        default:
          throw new Error('Invalid verification method');
      }

      if (result.isValid) {
        toast.success('Certificate verified successfully!');
      } else {
        toast.error('Certificate verification failed');
      }
      
      return result;
    } catch (error) {
      toast.error(error.message);
      return {
        success: false,
        isValid: false,
        message: error.message
      };
    }
  }

  async loadDashboardData() {
    try {
      const [certificates, stats] = await Promise.all([
        this.model.getMyCertificates(),
        this.model.getVerificationStats()
      ]);

      return {
        totalCertificates: certificates.length,
        recentCertificates: certificates.slice(0, 5),
        verificationStats: stats
      };
    } catch (error) {
      toast.error('Failed to load dashboard data');
      return {
        totalCertificates: 0,
        recentCertificates: [],
        verificationStats: null
      };
    }
  }

  filterCertificates(certificates, filter) {
    if (filter === 'ALL') return certificates;
    return certificates.filter(cert => cert.status === filter);
  }

  getStatusBadgeClass(status) {
    return this.model.getStatusBadgeClass(status);
  }

  formatDate(dateString) {
    return this.model.formatDate(dateString);
  }

  isLoading() {
    return this.model.loading;
  }

  getCurrentCertificate() {
    return this.model.currentCertificate;
  }

  getCertificates() {
    return this.model.certificates;
  }

  getStats() {
    return this.model.stats;
  }
}

export default new CertificateController();